import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const createSelectors = parentReducer => {
    return new class {
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalDetailWidget_reducer"];
            return reducer.users;
        };
        selectReportTypes = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalDetailWidget_reducer"];
            return reducer.reportTypes;
        };
        selectToDate = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.toDate;
        };
        selectFromDate = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportTotalBarChartWidget_reducer"];
            return reducer.fromDate;
        };
        selectReports = createSelector(
            [
                this.selectUsers,
                this.selectReportTypes,
                this.selectFromDate,
                this.selectToDate
            ],
            (
                users = false,
                reportTypes = false,
                fromdate = false,
                todate = false
            ) => {
                if (users && reportTypes) {
                    let reportsPerUserPerReportType = Object.keys(
                        reportTypes
                    ).map(e => {
                        let reportTotal = _.compact(
                            getReportTypePerUser(users, e)
                        );
                        if (fromdate) {
                            fromdate = moment(fromdate, "DD/MM/YYYY");
                            if (todate === false) {
                                todate = fromdate;
                            } else todate = moment(todate, "DD/MM/YYYY");
                            reportTotal = filterByDate(
                                reportTotal,
                                fromdate,
                                todate
                            );
                        }
                        if (reportTotal.length === 0) {
                            return {
                                reportType: e,
                                reportTotal: 0
                            };
                        } else {
                            let numReports = 0;
                            reportTotal.map(e => {
                                numReports += Object.keys(e).length;
                                return true;
                            });
                            return {
                                reportType: e,
                                reportTotal: numReports
                            };
                        }
                    });
                    let total = 0;
                    Object.keys(reportsPerUserPerReportType).map(e => {
                        total += reportsPerUserPerReportType[e].reportTotal;
                        return true;
                    });
                    return { ...reportsPerUserPerReportType, total };
                } else return false;
            }
        );
    }();
};

const getReportTypePerUser = (users, reportType) => {
    return Object.keys(users).map(e => {
        return _.get(users[e], `reports.${reportType}`) || null;
    });
};
const filterByDate = (orderedDailyReports, dateFrom, dateTo) => {
    return orderedDailyReports.map(e => {
        return _.filter(e, f => {
            let date = f.timestamp.split(" ")[0];
            let current = moment(date, "DD-MM-YYYY");
            return current.isBetween(dateFrom, dateTo, null, "[]");
        });
    });
};
export default createSelectors;
